import { routeAccess } from 'app/access';
import RequireAuth from 'app/components/RequireAuth';
import { lazy } from 'react';
import { Route } from 'react-router';

const LinesRoute = lazy(() => import('./lines/LinesRoute'));
const CreateLineRoute = lazy(() => import('./lines/CreateLineRoute'));
const LineRoute = lazy(() => import('./lines/LineRoute'));
const PointOfSalesRoute = lazy(() => import('./point-of-sales/PointOfSalesRoute'));
const PointOfSaleRoute = lazy(() => import('./point-of-sales/PointOfSaleRoute'));
const CreatePointOfSaleRoute = lazy(() => import('./point-of-sales/CreatePointOfSaleRoute'));
const DistributionChannelsRoute = lazy(() => import('./distribution-channels/DistributionChannelsRoute'));
const DistributionChannelCreate = lazy(() => import('./distribution-channels/CreateDistributionChannelRoute'));
const DistributionChannelRoute = lazy(() => import('./distribution-channels/DistributionChannelRoute'));

export const RegisterRoutes = [
  <Route
    key="point-of-sale"
    path="/point-of-sale"
    element={
      <RequireAuth {...routeAccess.register}>
        <PointOfSalesRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="point-of-sale-new"
    path="/point-of-sale/new"
    element={
      <RequireAuth {...routeAccess.registerCreate}>
        <CreatePointOfSaleRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="point-of-sale-id"
    path="/point-of-sale/:id"
    element={
      <RequireAuth {...routeAccess.register}>
        <PointOfSaleRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="dist-channels"
    path="/dist-channels"
    element={
      <RequireAuth {...routeAccess.register}>
        <DistributionChannelsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="dist-channels-new"
    path="dist-channels/new"
    element={
      <RequireAuth {...routeAccess.registerCreate}>
        <DistributionChannelCreate />
      </RequireAuth>
    }
  />,
  <Route
    key="dist-channels-id"
    path="/dist-channels/:id"
    element={
      <RequireAuth {...routeAccess.register}>
        <DistributionChannelRoute />
      </RequireAuth>
    }
  />,
];

export const RegisterWithChartOfAccountsRoutes = [
  <Route
    key="lines"
    path="lines"
    element={
      <RequireAuth {...routeAccess.lines}>
        <LinesRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="lines-new"
    path="lines/new"
    element={
      <RequireAuth {...routeAccess.linesWrite}>
        <CreateLineRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="lines-id"
    path="lines/:id"
    element={
      <RequireAuth {...routeAccess.lines}>
        <LineRoute />
      </RequireAuth>
    }
  />,
];
